import { Cascader as OriginalCascader } from 'antd';
import { withWrap } from '../../utils/hoc';
const Cascader = withWrap(OriginalCascader);
export default Cascader;
